export enum Platform {
    null = "null",
    iOS = "iOS",
    Android = "Android",
    Web = "Web",
    Windows = "Windows",
    MacOS = "MacOS",
    Linux = "Linux",
}

export const platformOptions = [
    Platform.iOS.toString(),
    Platform.Android.toString(),
    Platform.Web.toString(),
    Platform.Windows.toString(),
    Platform.MacOS.toString(),
    Platform.Linux.toString(),
]

export function stringToPlatform(platform: string) {
    switch (platform) {
        case Platform.iOS.toString():
            return Platform.iOS;
        case Platform.Android.toString():
            return Platform.Android;
        case Platform.Web.toString():
            return Platform.Web;
        case Platform.Windows.toString():
            return Platform.Windows;
        case Platform.MacOS.toString():
            return Platform.MacOS;
        case Platform.Linux.toString():
            return Platform.Linux;
        default:
            return Platform.null;
    }
}